var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "page-help" }, [
        _c("div", { staticClass: "page-help__title" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("front.help.titles.help_center")))])
        ]),
        _c("div", { staticClass: "page-help__body" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "page-help__search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchText,
                    expression: "searchText"
                  }
                ],
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("front.search.form.input_placeholder")
                },
                domProps: { value: _vm.searchText },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchText = $event.target.value
                  }
                }
              }),
              _vm.searchResults.length ||
              (_vm.searchText && !_vm.searchResults.length)
                ? _c("div", { staticClass: "page-help__search_results" }, [
                    _vm.searchResults.length
                      ? _c(
                          "ul",
                          _vm._l(_vm.searchResults, function(item, index) {
                            return _c(
                              "li",
                              { key: index },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: item.pageUrl } },
                                  [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(item.question)
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm.searchText && !_vm.searchResults.length
                      ? _c("div", { staticClass: "null" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("front.help.messages.no_one_item_found")
                              ) +
                              "\n                        "
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _c("div", { staticClass: "page-help__category" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("front.help.titles.popular_topics")))
              ]),
              _c(
                "ul",
                _vm._l(_vm.categories, function(item, index) {
                  return _c(
                    "li",
                    { key: index },
                    [
                      _c("router-link", { attrs: { to: item.pageUrl } }, [
                        _c("img", {
                          attrs: { src: item.image, alt: item.title }
                        }),
                        _c("span", {
                          domProps: { textContent: _vm._s(item.title) }
                        })
                      ])
                    ],
                    1
                  )
                }),
                0
              )
            ])
          ]),
          _c("div", { staticClass: "page-help__bottom" }, [
            _c(
              "div",
              { staticClass: "container" },
              [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("front.help.titles.need_more_help")))
                ]),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function($event) {
                        _vm.supportDialog = true
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("front.help.button.contact_us")))]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog-support",
            "max-width": "900px",
            persistent: _vm.isDialogPersistent
          },
          model: {
            value: _vm.supportDialog,
            callback: function($$v) {
              _vm.supportDialog = $$v
            },
            expression: "supportDialog"
          }
        },
        [
          _vm.supportDialog
            ? _c("support-popup", {
                on: {
                  close: function($event) {
                    _vm.supportDialog = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }